__turbopack_context__.v({
  "active": "HFb7Nq_active",
  "backButton": "HFb7Nq_backButton",
  "header": "HFb7Nq_header",
  "item": "HFb7Nq_item",
  "link": "HFb7Nq_link",
  "list": "HFb7Nq_list",
  "menu": "HFb7Nq_menu",
  "text": "HFb7Nq_text",
  "textOnly": "HFb7Nq_textOnly",
  "title": "HFb7Nq_title",
  "titleLink": "HFb7Nq_titleLink",
});
